"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Spinner = props => {
  const {
    size,
    className,
    overlay,
    isLoading
  } = props;
  const additionalClasses = size === 'small' ? 'lds-spinner-small' : '';
  if (overlay) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner-overlay ${isLoading && 'is-active'}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner ${additionalClasses} ${className}`
    }, /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null)));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `lds-spinner ${additionalClasses} ${className}`
  }, /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null));
};
Spinner.propTypes = {
  size: _propTypes.default.string,
  className: _propTypes.default.string,
  overlay: _propTypes.default.bool,
  isLoading: _propTypes.default.bool
};
Spinner.defaultProps = {
  size: '',
  className: '',
  overlay: false,
  isLoading: false
};
var _default = exports.default = Spinner;
//# sourceMappingURL=Spinner.js.map